if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[data-product-select]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        if (! this.form.checkValidity()) {
          this.form.reportValidity()
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Eraya price testing: bundle/upsell products post several `id[]` values
        // with ONE shared `properties[...]` block, which can't carry a per-variant
        // test price — and a shared price would wrongly apply to the untested
        // add-ons. Reshape those into Shopify's `items[]` form format so each line
        // carries its OWN properties; the Eraya SDK then stamps the test price onto
        // only the tested line. Every other field (sections, attributes[…],
        // selling_plan, product-id, …) is preserved verbatim. Single-variant adds
        // (no `id[]`, or a lone `id[]`) are left exactly as the native form built
        // them, so normal products are completely unaffected.
        config.body = this.buildErayaBundleBody(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if(typeof publish !== 'undefined') publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // Reshape a multi-`id[]` bundle add into Shopify's items[] form format so
      // per-line properties (and therefore per-variant Eraya test prices) apply.
      // Returns the original FormData untouched unless there are 2+ `id[]` values.
      buildErayaBundleBody(formData) {
        try {
          const ids = formData.getAll('id[]').filter((v) => String(v).trim() !== '');
          if (ids.length < 2) return formData; // not a multi-line add — leave as-is

          const converted = new FormData();
          const lineProps = []; // shared properties -> applied to every line
          let lineQty = '1';

          formData.forEach((value, key) => {
            if (key === 'id[]') return; // becomes items[n][id]
            if (key === 'quantity') {
              lineQty = value;
              return;
            } // becomes items[n][quantity]
            const pm = key.match(/^properties\[(.+)\]$/);
            if (pm) {
              lineProps.push([pm[1], value]);
              return;
            } // becomes items[n][properties][k]
            converted.append(key, value); // sections, attributes[…], selling_plan, etc. unchanged
          });

          ids.forEach((variantId, i) => {
            converted.append(`items[${i}][id]`, variantId);
            converted.append(`items[${i}][quantity]`, lineQty);
            lineProps.forEach(([k, v]) => {
              converted.append(`items[${i}][properties][${k}]`, v);
            });
          });

          return converted;
        } catch (e) {
          // Never block add-to-cart — fall back to the native body on any error.
          console.error('[Eraya] bundle body reshape failed, using native body', e);
          return formData;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
